import gsap from 'gsap';
import { random } from 'lodash';
import {
  Loader,
  Point,
  Sprite,
  Texture,
} from 'pixi.js';
import state from '../state';
import ticker from '../ticker';
import vars from '../vars';

class Smoke {
  constructor(parent, player) {
    this.parent = parent;
    this.player = player;
    this.spawnDelay = 200;
    this.lastTime = Date.now();

    this.sprite = new Sprite();
    this.container = new Sprite(Texture.EMPTY);

    this.resize();
    this.sprite.addChild(this.container);
    this.parent.addChild(this.sprite);

    this.frameHandler = () => { this.frame(); };
  }

  resize() {
    this.container.width = vars.layout.FRAME_WIDTH;
    this.container.height = 150;
    this.sprite.position.y = this.player.sprite.position.y + 70;
  }

  frame() {
    const delay = Date.now() - this.lastTime;
    if (delay >= this.spawnDelay) {
      this.spawn();
      this.lastTime = Date.now();
    }
  }

  startSpawn() {
    ticker.add(this.frameHandler);
  }

  stopSpawn() {
    ticker.remove(this.frameHandler);
  }

  spawn() {
    const r = random(0, 1, false);
    const particle = new Sprite(Loader.shared.resources['textures/SMOKE'].texture);
    particle.position.x = this.player.sprite.position.x + (r === 1 ? 10 : -10);
    particle.position.y = this.container.height;
    particle.anchor = new Point(0.5, 0.5);
    const s = random(10, 20, true);
    particle.width = s;
    particle.height = s;
    this.sprite.addChild(particle);

    gsap.to(particle, {
      // x: `-=${random(8, 12, true) * (r === 1 ? -1 : 1)}`,
      angle: random(0, 90, false),
      ease: 'power2.out',
      duration: 0.6,
      onComplete: () => particle.destroy(),
      onUpdate: () => {
        particle.position.x += r === 1 ? 0.1 : -0.1;
        particle.position.y -= state.speed * ticker.speed;
      },
    });
    gsap.to(particle, {
      alpha: 0,
      duration: 0.2,
      delay: 0.4,
      ease: 'power2.out',
    });
  }
}

export default Smoke;
